import $ from "jquery";

export default {
    init() {
        $('.policies__to-back-link').on('click', (e) => {
            e.preventDefault();
            let last_url = document.referrer;
            if (last_url !== '') {
                history.back();
            } else {
                window.location = $('.policies__to-back-link').attr('href');
            }
        });
    },

    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};
